
/**
 * It takes in a list of human resources and a list of concepts, and
 * @param {HumanResources} cleanHumanResources - The human resources previously cleaned by the form in section
 * @param {Concepts} concepts - The list of concepts from the query
 * @returns {HumanResourceTypes}
 * returns
 * an object with the following properties:
 * - trueHumanResources: a list of human resources which concept type was human resource
 * - falseHumanResources: a list of human resources which concept type was not  human resource
 * - trueHumanResourcesIds: a list of human resources ids which concept type was human resource
 * - falseHumanResourcesIds: a list of human resources ids which concept type was not  human resource
 */
export function useHumanResourceCleanner (cleanHumanResources, concepts) {
  const dirtyHumanResources = concepts
    ?.filter(concept => concept?.humanResource?.length > 0)
    ?.map(concept => concept?.humanResource[0]) || []

  const trueHumanResourcesIdsFromConcepts = concepts
    ?.filter(concept => concept?.type?.includes("HUMAN_RESOURCE"))
    ?.map(concept => concept?.humanResource[0]?.id) || []

  /* This array should be redundant but is a second validation for the concept types
  for removes falsy human resources.*/
  const trueHumanResources = cleanHumanResources
    ?.filter(humanResource => trueHumanResourcesIdsFromConcepts?.includes(humanResource.id)) || cleanHumanResources
  const trueHumanResourcesIds = trueHumanResources?.map(humanResource => humanResource.id) || []

  const falseHumanResources = dirtyHumanResources
    ?.filter(humanResource => !trueHumanResourcesIdsFromConcepts?.includes(humanResource.id)) || []
  const falseHumanResourcesIds = falseHumanResources?.map(humanResource => humanResource.id) || []

  return { trueHumanResources, falseHumanResources, trueHumanResourcesIds, falseHumanResourcesIds }
}

/**
 * @typedef {array.<HumanResource>} HumanResources
 */
/**
 * @typedef {array.<Object>} Concepts
/**
 * @typedef {Object} HumanResourceTypes
 * @property {array.<HumanResource>} trueHumanResources
 * @property {array.<HumanResource>} falseHumanResources
 * @property {array.<string>} trueHumanResourcesIds
 * @property {array.<string>} falseHumanResourcesIds
 */
/**
 * @typedef {Object} HumanResource
 * @property {String} position
 * @property {String} name
 * @property {Number} hours
 * @property {String} contractType
 * @property {Boolean} benefits
*/